import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { jsx as _jsx } from "react/jsx-runtime";
function Accordion(props) {
  const {
    children,
    defaultOpen,
    title
  } = props;
  return /*#__PURE__*/_jsx(AccordionItem, {
    title: title,
    defaultOpen: defaultOpen,
    size: "small",
    children: children
  });
}
export default Accordion;